// Priority countries we want at the top
const priorityCountries = [
  "United States",
  "Australia",
  "Canada",
  "Germany",
  "India",
  "Japan",
  "Singapore",
  "United Kingdom"
];

// Fetch countries and build dropdown
fetch("https://restcountries.com/v3/all?fields=cca2,name")
  .then(res => res.json())
  .then(data => {
    const select = document.getElementById("country-select");
    if (!select) return;

    select.innerHTML = "";

    // Default placeholder
    const defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.textContent = "Select a country";
    defaultOption.disabled = true;
    defaultOption.selected = true;
    select.appendChild(defaultOption);

    // Sort API countries alphabetically
    const sortedCountries = data.sort((a, b) => 
      a.name.common.localeCompare(b.name.common)
    );

    // Add PRIORITY COUNTRIES first
    priorityCountries.forEach(prioName => {
      const match = sortedCountries.find(
        c => c.name.common.toLowerCase() === prioName.toLowerCase()
      );
      if (match) {
        const option = document.createElement("option");
        option.value = match.cca2?.toLowerCase() || "";
        option.textContent = match.name.common;
        select.appendChild(option);
      }
    });

    // Add separator line
    const separator = document.createElement("option");
    separator.disabled = true;
    separator.textContent = "──────────";
    select.appendChild(separator);

    // Add the rest of the countries, excluding the ones already highlighted
    sortedCountries.forEach(country => {
      if (!priorityCountries.some(
        p => p.toLowerCase() === country.name.common.toLowerCase()
      )) {
        const option = document.createElement("option");
        option.value = country.cca2?.toLowerCase() || "";
        option.textContent = country.name.common;
        select.appendChild(option);
      }
    });

    // Init autocomplete AFTER we populate
    initAutocomplete();
  })
  .catch(err => console.error(err));

let autocomplete;

// Initialize Google Places Autocomplete with safe restrictions
function initAutocomplete() {
  const input = document.getElementById("quote-address");
  const countrySelect = document.getElementById("country-select");
  if (!input || !countrySelect) return;

  const getCountryRestriction = () => {
    const val = countrySelect.value?.trim().toUpperCase();
    return val || "US";
  };

  autocomplete = new google.maps.places.Autocomplete(input, {
    types: ["address"],
    componentRestrictions: { country: getCountryRestriction() },
    fields: ["address_components", "geometry"]
  });

  function handleAddressOrContactChange({ resetAddressFields = false } = {}) {
  // If triggered by country change → reset fields
  if (resetAddressFields) {
    document.getElementById("quote-city").value = "";
    document.getElementById("quote-state").value = "";
    document.getElementById("quote-zip").value = "";
    document.getElementById("quote-address").value = "";
  }

  setupShippingButtonValidation();

  resetShippingRates();

  console.log("Shipping Rates Fired.")

}

countrySelect.addEventListener("change", () => {
  autocomplete.setOptions({
    componentRestrictions: { country: getCountryRestriction() }
  });

  // Country change resets dependent fields
  handleAddressOrContactChange({ resetAddressFields: true });
});

["quote-email", "quote-address", "quote-city", "quote-state", "quote-zip"].forEach(id => {
  const field = document.getElementById(id);
  if (field) {
    field.addEventListener("input", () => handleAddressOrContactChange());
  }
});

autocomplete.addListener("place_changed", () => {
  const place = autocomplete.getPlace();
  if (!place.address_components) return;

  const getComponent = (type, short = false) =>
    place.address_components.find(c => c.types.includes(type))?.[short ? "short_name" : "long_name"] || "";

  document.getElementById("quote-state").value = getComponent("administrative_area_level_1", true);
  document.getElementById("quote-city").value = getComponent("locality");
  document.getElementById("quote-zip").value = getComponent("postal_code");

  setupShippingButtonValidation();

  ['quote-city', 'quote-state', 'quote-zip'].forEach(id => {
    const field = document.getElementById(id);
    if (field) toggleFieldHighlight(field);
  });

  closeAllGooglePredictionDropdowns();
});

function closeAllGooglePredictionDropdowns() {
  const pacContainers = document.querySelectorAll('.pac-container');
  pacContainers.forEach(container => {
    container.style.display = 'none';
  });
}
}

let ignoreNextCartUpdate = false;
let lastShippingSnapshot = null;
let shippingRatesVisible = false;

// Track address changes BUT don’t reset on country change
function trackAddressChanges() {
  const fields = document.querySelectorAll(
    "#quote-address, #quote-city, #quote-state, #quote-zip, #quote-suite-number"
  );

  fields.forEach((field) => {
    field.addEventListener("input", () => {
      if (!shippingRatesVisible) return; // don’t reset if rates not visible
      console.log("Address changed. Resetting shipping rates.");
      resetShippingRates();
    });
  });
}

// Shipping button validation stays same
function validateShippingButton() {
  const address = document.getElementById("quote-address").value.trim();
  const company = document.getElementById("quote-company").value.trim();
  const city = document.getElementById("quote-city").value.trim();
  const state = document.getElementById("quote-state").value.trim();
  const zip = document.getElementById("quote-zip").value.trim();
  const email = document.getElementById("quote-email").value.trim();
  const firstName = document.getElementById("quote-first-name").value.trim();
  const lastName = document.getElementById("quote-last-name").value.trim();

  const button = document.querySelector(".quote-shipping-button");
  const isValid = address && city && state && zip && email && firstName && lastName;

  button.classList.toggle("disabled", !isValid);
  button.setAttribute("tabindex", isValid ? "0" : "-1");
  button.setAttribute("aria-disabled", isValid ? "false" : "true");
  button.disabled = !isValid;

  if (isValid) button.classList.add("quote-address-available");
  else button.classList.remove("quote-address-available");
}

function setupShippingButtonValidation() {
  ["quote-address","quote-city","quote-state","quote-zip","quote-email","quote-first-name","quote-last-name","quote-company"].forEach(id => {
    const el = document.getElementById(id);
    if (el) el.addEventListener("input", validateShippingButton);
  });
  validateShippingButton();
}

// Sync quoteCart → Shopify cart
async function syncQuoteCartToShopifyCart() {
  const cart = JSON.parse(sessionStorage.getItem("quoteCart") || "[]");
  if (!cart.length) {
    console.warn("No products in quoteCart to sync.");
    return;
  }
  await fetch("/cart/clear.js", { method: "POST" });

  const itemsToAdd = cart.map(item => ({
    id: item.variant_id,
    quantity: item.quantity
  }));

  console.log("Syncing to Shopify cart:", itemsToAdd);
  return fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items: itemsToAdd })
  }).then(res => res.json());
}

async function fetchShippingRates() {
  const address = getCurrentAddressState();

  if (!address || !address.city || !address.state || !address.country || !address.zip) {
    alert("Please complete the address to calculate shipping.");
    return [];
  }

  await syncQuoteCartToShopifyCart();

  const payload = {
    shipping_address: {
      zip: address.zip,
      country: address.country.toUpperCase(),
      province: address.state
    }
  };

  console.log("Fetching ASM rates with:", payload);

  // Original ASM shipping fetch
  const res = await fetch("/cart/shipping_rates.json", {
    method: "POST",
    headers: { "Content-Type": "application/json", "Accept": "application/json" },
    body: JSON.stringify(payload)
  });

  const data = await res.json();
  console.log("ASM shipping rates response:", data);

const mapped = (data?.shipping_rates || []).map(rate => {
  const formattedPrice = `$${parseFloat(rate.price).toFixed(2)}`;

  const deliveryText = Array.isArray(rate.delivery_range) && rate.delivery_range.length
    ? ` (${rate.delivery_range.join(" - ")})`
    : "";

  return {
    id: rate.code || rate.name,
    label: `${rate.name}${deliveryText}`,
    price: formattedPrice
  };
});

  // Call proxy to calculate taxes
  const cart = JSON.parse(sessionStorage.getItem("quoteCart") || "[]");
  const savedProducts = cart.map(item => ({
    variantId: `gid://shopify/ProductVariant/${item.variant_id}`,
    quantity: item.quantity
  }));

  const proxyPayload = {
    savedProducts,
    city: address.city,
    state: address.state,
    country: address.country.toUpperCase(),
    zip: address.zip
  };

  console.log("Sending payload to proxy:", JSON.stringify(proxyPayload, null, 2));

  try {
    const proxyRes = await fetch("/apps/proxy", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(proxyPayload)
    });

    if (!proxyRes.ok) throw new Error(`Proxy error: HTTP ${proxyRes.status}`);

    const proxyData = await proxyRes.json();
    console.log("Proxy response:", proxyData);

    const calculated = proxyData?.data?.draftOrderCalculate?.calculatedDraftOrder;
    if (calculated) {
      const totalTaxSet = calculated.totalTaxSet?.presentmentMoney || {};

      const amountNum = Number.parseFloat(
        totalTaxSet.amount != null ? String(totalTaxSet.amount).replace(/,/g, "") : "0"
      );
      const taxLines = (calculated.taxLines || []).map(line => ({
        title: line.title,
        rate: line.ratePercentage,
        amount: Number.parseFloat(
          (line.priceSet?.shopMoney?.amount != null ? String(line.priceSet.shopMoney.amount) : "0").replace(/,/g, "")
        )
      }));

      const quoteTax = {
        amount: Number.isFinite(amountNum) ? amountNum : 0,
        currency: totalTaxSet.currencyCode || "USD",
        lines: taxLines
      };

      // Save tax info as NUMBERS
      localStorage.setItem("quoteTax", JSON.stringify(quoteTax));
      console.log("Saved quoteTax:", quoteTax);
    } else {
      console.warn("Proxy returned no calculatedDraftOrder for taxes.");
    }
  } catch (err) {
    console.error("Failed to fetch proxy:", err);
  }

  console.log("Clearing temporary Shopify cart…");
  await fetch("/cart/clear.js", { method: "POST" });

  // If no shipping rates found, add fallback option
  if (!mapped.length) {
  console.warn("No shipping rates returned. Adding fallback option.");

  const fallbackRate = {
    id: "pending-quote",
    label: "Additional Information Needed for Shipping Quote",
    price: ""
  };

  sessionStorage.setItem("selectedShippingOption", fallbackRate.label);
  sessionStorage.setItem("selectedShippingRate", "0");

  return [fallbackRate];
}

  return mapped;
}

function getCustomerInfo() {
  return {
    email: document.getElementById("quote-email")?.value.trim() || "",
    firstName: document.getElementById("quote-first-name")?.value.trim() || "",
    lastName: document.getElementById("quote-last-name")?.value.trim() || "",
    company: document.getElementById("quote-company")?.value.trim() || "",
    city: document.getElementById("quote-city")?.value.trim() || "",
    state: document.getElementById("quote-state")?.value.trim() || "",
    zip: document.getElementById("quote-zip")?.value.trim() || "",
    address: document.getElementById("quote-address")?.value.trim() || "",
    country: document.getElementById("country-select")?.value?.trim() || ""
  };
}

document.querySelector(".quote-shipping-button").addEventListener("click", (e) => {
  const btn = e.currentTarget;
  const isDisabled =
    btn.classList.contains("disabled") ||
    btn.getAttribute("aria-disabled") === "true";
  if (isDisabled) return;

  // Capture & save customer info before fetching rates
  const customerInfo = getCustomerInfo();
  sessionStorage.setItem("quoteCustomerInfo", JSON.stringify(customerInfo));
  console.log("Saved customer info:", customerInfo);

  const cart = sessionStorage.getItem("quoteCart");
  const address = getCurrentAddressState();
  lastShippingSnapshot = { cart, address };

  btn.disabled = true;
  btn.setAttribute("aria-disabled", "true");
  btn.innerHTML = `
    <span class="loader-spinner"></span>
    <span class="loading-text">Calculating...</span>
  `;
  btn.classList.add("loading");

  fetchShippingRates()
    .then(rates => {
      if (!rates.length) {
        alert("No shipping options for this address.");
        return;
      }
      renderShippingRates(rates);
      document.getElementById("shipping-methods-container").classList.remove("dimmed", "hidden");
      document.getElementById("shipping-warning").classList.add("hidden");
      document.getElementById("submit-quote").classList.add("submit-quote-available");
      shippingRatesVisible = true;
    })
    .catch(err => {
      console.error("Error fetching shipping rates:", err);
    })
    .finally(() => {
      btn.disabled = false;
      btn.setAttribute("aria-disabled", "false");
      btn.innerHTML = "Get Shipping Rates";
      btn.classList.remove("loading");
    });
});

function renderShippingRates(rates) {
  const container = document.getElementById("shipping-methods-container");
  container.innerHTML = "";

  rates.forEach(rate => {
    const option = document.createElement("div");
    option.className = "shipping-rate-option";
    option.innerHTML = `
      <label>
        <input type="radio" name="shipping_rate" value="${rate.id}" data-price="${parseFloat(
          rate.price.replace(/[^\d.]/g, "")
        )}" />
        <span class="label-text">
          <span class="label-title">${rate.label}</span>
          <span class="label-price">${rate.price}</span>
        </span>
      </label>
    `;

    const radio = option.querySelector('input[type="radio"]');
    radio.addEventListener("change", (e) => {
      document.querySelectorAll(".shipping-rate-option.selected").forEach(el => el.classList.remove("selected"));
      option.classList.add("selected");

      const selectedPrice = parseFloat(e.target.dataset.price);
      if (!isNaN(selectedPrice)) {
        sessionStorage.setItem("selectedShippingRate", selectedPrice);
      }

      sessionStorage.setItem("selectedShippingOption", rate.label);

      ignoreNextCartUpdate = true;
      window.dispatchEvent(new Event("quoteCartUpdated"));

      const submitButton = document.getElementById("submit-quote");
      if (submitButton) {
        submitButton.classList.add("submit-quote-active");
        submitButton.removeAttribute("disabled");
      }
    });

    container.appendChild(option);
  });
}

// Reset shipping rates
function resetShippingRates() {
  shippingRatesVisible = false;
  sessionStorage.removeItem("selectedShippingRate");
  localStorage.removeItem("quoteTax");


  const container = document.getElementById("shipping-methods-container");
  const warning = document.getElementById('shipping-warning');

  if(container){
    container.classList.add('hidden');
    container.innerHTML = "";
  }
  if(warning){
    warning.classList.remove("hidden");
  }

  const submitButton = document.getElementById("submit-quote");
  if (submitButton) {
    submitButton.classList.remove("submit-quote-active");
    submitButton.setAttribute("disabled", "true");
    submitButton.setAttribute("aria-disabled", "true");
  }

  window.dispatchEvent(new Event("quoteCartUpdated"));
  setupShippingButtonValidation();
}

window.addEventListener("shippingRatesReset", (e) => {
  clearTimeout(window.__shippingResetDebounce);
  window.__shippingResetDebounce = setTimeout(() => {
    resetShippingRates();
  }, 150);
});

function getCurrentAddressState() {
  return {
    address: document.getElementById("quote-address")?.value,
    city: document.getElementById("quote-city")?.value,
    state: document.getElementById("quote-state")?.value,
    zip: document.getElementById("quote-zip")?.value,
    suite: document.getElementById("quote-suite-number")?.value,
    country: document.getElementById("country-select")?.value,
  };
}

window.addEventListener("load", () => {
  const requiredSelectors = [
    '#quote-email',
    '#quote-first-name',
    '#quote-last-name',
    '#country-select',
    '#quote-address',
    '#quote-city',
    '#quote-state',
    '#quote-zip',
    '#quote-company'
  ];
  const requiredFields = document.querySelectorAll(requiredSelectors.join(", "));

  if (!requiredFields.length) return;

  requiredFields.forEach(field => {
    if (!field.value.trim()) {
      field.classList.add("initial-pulse");
    }
  });

  setTimeout(() => {
    requiredFields.forEach(field => field.classList.remove("initial-pulse"));
  }, 2500);

  const formContainer = document.querySelector(".quote-customer");
  let liveHighlightEnabled = false;

  formContainer.addEventListener("focusin", () => {
    if (liveHighlightEnabled) return; 
    liveHighlightEnabled = true;

    requiredFields.forEach(field => {
      
      toggleFieldHighlight(field);

      field.addEventListener("input", () => toggleFieldHighlight(field));
      field.addEventListener("focus", () => field.classList.remove("highlight-required"));
      field.addEventListener("blur", () => toggleFieldHighlight(field));
    });
  }, { once: true });
});

function toggleFieldHighlight(field) {
  if (field.value.trim()) {
    field.classList.remove("highlight-required");
  } else {
    field.classList.add("highlight-required");
  }
}

function attachSubmitQuoteListener() {
  const submitBtn = document.getElementById("submit-quote");
  if (!submitBtn) {
    console.warn("#submit-quote not found yet.");
    return;
  }

  if (submitBtn.dataset.listenerAttached) {
    console.log("Submit listener already attached, skipping.");
    return;
  }

  console.log("Attaching listener to #submit-quote");

  submitBtn.addEventListener("click", () => {
    console.log("Submit Quote button clicked!");

    const quoteData = prepareQuoteData();
    if (quoteData) {
      console.log("Quote data prepared, sending...");
      sendQuoteData(quoteData);
    } else {
      console.error("No quote data available");
    }
  });

  submitBtn.dataset.listenerAttached = "true";
}

const originalRenderShippingRates = renderShippingRates;
renderShippingRates = function (rates) {
  originalRenderShippingRates(rates);

  setTimeout(() => {
    attachSubmitQuoteListener();
  }, 100);
};

function prepareQuoteData() {
  const quoteCart = sessionStorage.getItem("quoteCart");
  if (!quoteCart) {
    console.error("No products found in sessionStorage.quoteCart");
    return null;
  }
  const parsedProducts = JSON.parse(quoteCart);

  // Shipping info
  const selectedShippingOption = sessionStorage.getItem("selectedShippingOption") || null;
  const selectedShippingRate = parseFloat(sessionStorage.getItem("selectedShippingRate") || "0");

  // Taxes
  let taxAmount = 0;
  const quoteTaxRaw = localStorage.getItem("quoteTax");
  if (quoteTaxRaw) {
    try {
      const taxData = JSON.parse(quoteTaxRaw);
      const n = Number(taxData?.amount);
      taxAmount = Number.isFinite(n) ? n : 0;
    } catch (e) {
      console.error("Failed to parse quoteTax", e);
    }
  }

  function ensureDecimalString(n) {
  const num = Number(n);
  if (!Number.isFinite(num)) return "0.00";
  return Number.isInteger(num) ? `${num}.00` : String(num);
}

  const storedCustomerInfo = JSON.parse(sessionStorage.getItem("quoteCustomerInfo") || "{}");
  console.log("Retrieved customer info from session:", storedCustomerInfo);

  // Customer notes
  const publicNotesInput = document.getElementById("quote-message");
  const publicNotes = publicNotesInput ? publicNotesInput.value.trim() : "";

const lineItems = parsedProducts.map(product => {

  const productId = product.product_id ? Number(product.product_id) : null;
  const variantId = product.variant_id ? Number(product.variant_id) : null;

  console.log("Raw product_id:", product.product_id, "→", productId);
  console.log(" Raw variant_id:", product.variant_id, "→", variantId);

  const priceNumber = product.price / 100;

  const fullImage = product.image?.startsWith("//")
    ? `https:${product.image}`
    : product.image;

  return {
    quantity: product.quantity,
    title: product.product_title,
    price: priceNumber,                
    original_line_price: priceNumber, 
    product_id: productId,             
    variant_id: variantId,            
    sku: product.sku,
    custom_product: false,             
    image: fullImage,                  
    variant_title: product.variant_name || "", 
    
    id: null,
    barcode: product.sku || null,
    custom_image_path: null,
    discount_amount: null,
    discount_reason: null,
    discount_total: null,
    discount_type: null,
    grams: null,
    item_properties: [],
    requires_shipping: true,
    taxable: true,
    url: null,
    total: priceNumber
  };
});

  const subtotal = parsedProducts.reduce((sum, p) => sum + (p.price / 100) * p.quantity, 0);
  const total = subtotal + selectedShippingRate + taxAmount;

  // Function to get the gclid value from localStorage
function getGclidFromLocalStorage() {
  const gclData = localStorage.getItem('_gcl_ls');

  if (gclData) {
    const parsedData = JSON.parse(gclData);
    return parsedData?.gclid?.value?.value || "0";
  }
  return null;
}

// Store Gclid in localStorage if found
const gclid = getGclidFromLocalStorage();

if (gclid) {
  localStorage.setItem('gclid', gclid); // Store Gclid separately for easy access
}

// Set the Gclid in the hidden input field when the form loads
document.addEventListener("DOMContentLoaded", function () {
  const storedGclid = localStorage.getItem('gclid');
  const gclidInput = document.getElementById('gclid-input');

  if (gclidInput && storedGclid) {
    gclidInput.value = storedGclid; // Set the value of the hidden input
  }

  // Debugging: Log the Gclid to ensure it's working
  console.log("Gclid Stored:", storedGclid);
  console.log("Hidden Input Value:", gclidInput ? gclidInput.value : "No input found");
});

function getCookieValue(name) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
        const [key, value] = cookie.split('=');
        if (key === name) {
            return decodeURIComponent(value);
        }
    }
    return null;
}

const uetmsclkidValue = getCookieValue('_uetmsclkid');

if (uetmsclkidValue && uetmsclkidValue.startsWith('_uet')) {
    const cleanedValue = uetmsclkidValue.replace('_uet', ''); // Remove '_uet' prefix
    localStorage.setItem('MSClickID', cleanedValue);
}

      // Defaults
      leadSource = 'direct';
      leadMedium = 'none';
      
      const urlParams = new URLSearchParams(window.location.search);
      
      // Check for Google Ads even without referrer
      if (urlParams.has('gclid') || urlParams.get('utm_medium') === 'cpc') {
        leadSource = 'google';
        leadMedium = 'cpc';
      }
      
      // Then check referrer if available
      if (document.referrer) {
        try {
          const referrerUrl = new URL(document.referrer);
          const refDomain = referrerUrl.hostname.replace(/^www\./, '').toLowerCase();
      
          if (refDomain.includes('google.')) {
            leadSource = 'google';
      
            // Only overwrite if not already set from gclid
            if (leadMedium !== 'cpc') {
              leadMedium = 'organic';
            }
      
          } else if (refDomain.includes('bing.')) {
            leadSource = 'bing';
            leadMedium = 'organic';
          } else if (refDomain.includes('yahoo.')) {
            leadSource = 'yahoo';
            leadMedium = 'organic';
          } else if (refDomain.includes('facebook.')) {
            leadSource = 'facebook';
            leadMedium = 'social';
          } else if (refDomain.includes('instagram.')) {
            leadSource = 'instagram';
            leadMedium = 'social';
          } else if (refDomain.includes('linkedin.')) {
            leadSource = 'linkedin';
            leadMedium = 'social';
          } else {
            leadSource = refDomain;
            leadMedium = 'referral';
          }
      
        } catch (error) {
          console.error('Error parsing referrer:', error);
        }
      }

  const Msclickid = localStorage.getItem("MSClickID") || "";

  const cart = JSON.parse(sessionStorage.getItem('quoteCart') || '[]');
 
const allCollections = new Set(
  cart
    .flatMap(it => Array.isArray(it.collections) ? it.collections : [])
    .filter(Boolean)
    .map(h => String(h).trim().toLowerCase())
);

console.log("allCollections:", [...allCollections]);

const targetHandles = [
  'mse-analytical-services',
  'materials-characterization-analytical-services',
  'materials-characterization-analytical-services-best-value'
];

const matchedTargets = targetHandles.filter(h => allCollections.has(h));
const belongsToAnyTarget = matchedTargets.length > 0;

console.log({ matchedTargets, belongsToAnyTarget });

const basePrefix = 'materials-characterization-analytical-services';
const hasBaseOrVariant = [...allCollections].some(h => h === basePrefix || h.startsWith(basePrefix + '-'));

console.log({ hasBaseOrVariant });

const belongsToTargetCollection = belongsToAnyTarget || hasBaseOrVariant;

const assigneeId = belongsToTargetCollection ? 560 : 559;

  const shippingObject = {
    shipping_handle: null,
    shipping_name: selectedShippingOption,
    shipping_price: selectedShippingRate.toFixed(2),
    shipping_total: selectedShippingRate.toFixed(2),
  };

  const quoteData = {
    email: storedCustomerInfo.email || "",
    first_name: storedCustomerInfo.firstName || "",
    last_name: storedCustomerInfo.lastName || "",
    remarks: publicNotes, 
    internal_notes: Msclickid,
    public_notes: leadSource || '',
    tags: leadMedium || '',
    customer_id: null,
    phone: null,
    subtotal: subtotal.toFixed(2),
    total_tax: taxAmount.toFixed(2),
    total: total.toFixed(2),

    assignee_id: assigneeId,

    custom_fields: [
      { id: 9040, name: "Gclid", value: gclid },
      { id: 6528, name: "Company", value: storedCustomerInfo.company || "" },
      { id: 9320, name: "Shipping", value: selectedShippingRate.toFixed(2)},
      { id: 9321, name: "Tax", value: ensureDecimalString(taxAmount) },
      { id: 9322, name: "Shipping Option", value: selectedShippingOption || "" },
      { id: 9328, name: "Address", value: storedCustomerInfo.address || "" },
      { id: 9329, name: "Zip", value: storedCustomerInfo.zip || "" },
      { id: 9330, name: "City", value: storedCustomerInfo.city || "" },
      { id: 9331, name: "State", value: storedCustomerInfo.state || "" },
      { id: 9332, name: "Country", value: storedCustomerInfo.country || "" },
      { id: 9041, name: 'Quote URL', value: "https://www.msesupplies.com/pages/quote-request" },
      { id: 9478, name: 'MSClickID', value: Msclickid || 0}
    ],

    line_items: lineItems
  };

  console.log("Prepared Quote Data for API:", quoteData);
  return quoteData;
}

// ✅ Clears all session/localStorage data related to the quote
function clearQuoteStorage() {
  sessionStorage.removeItem("quoteCart");
  sessionStorage.removeItem("selectedShippingRate");
  sessionStorage.removeItem("selectedShippingOption");
  sessionStorage.removeItem("quoteCustomerInfo");
  localStorage.removeItem("quoteTax");

  console.log("✅ Quote session & local storage cleared!");
}

const TARGET_COLLECTION_HANDLES = new Set([
  'mse-analytical-services',
  'mse-analytical-service', // handle both just in case
  'materials-characterization-analytical-services',
  'materials-characterization-analytical-services-best-value'
]);
const TARGET_BASE_PREFIX = 'materials-characterization-analytical-services';

function belongsToAnalyticalServices(item) {
  const cols = Array.isArray(item.collections) ? item.collections : [];
  return cols
    .filter(Boolean)
    .map(h => String(h).trim().toLowerCase())
    .some(h =>
      TARGET_COLLECTION_HANDLES.has(h) ||
      h === TARGET_BASE_PREFIX ||
      h.startsWith(TARGET_BASE_PREFIX + '-')
    );
}

// ✅ Sync quoteCart → Shopify cart, excluding $0 products
async function syncQuoteCartToShopifyCart() {
  const cart = JSON.parse(sessionStorage.getItem("quoteCart") || "[]");
  if (!cart.length) {
    console.warn("No products in quoteCart to sync.");
    return;
  }

  // Filter out products with price 0.00
  const validProducts = cart.filter(item => {
    const price = Number(item.price);
    const zeroOrInvalidPrice = !Number.isFinite(price) || price <= 0;
    const isAnalyticalService = belongsToAnalyticalServices(item);

    if (zeroOrInvalidPrice) {
      console.warn("Skipping product with $0/invalid price:", item);
      return false;
    }

    if (isAnalyticalService) {
      console.warn("Skipping analytical-services product:", item);
      return false;
    }

    return true;
  });

  if (!validProducts.length) {
    console.warn("No valid priced products to sync.");
    return;
  }

  // Clear current Shopify cart
  await fetch("/cart/clear.js", { method: "POST" });

  const itemsToAdd = validProducts.map(item => ({
    id: item.variant_id,
    quantity: item.quantity
  }));

  console.log("Syncing to Shopify cart:", itemsToAdd);

  return fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items: itemsToAdd })
  }).then(res => res.json());
}

// ✅ Submit Quote and handle UI
function sendQuoteData(quoteData) {
  const submitBtn = document.getElementById("submit-quote");

  // Disable button & show loader
  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.setAttribute("aria-disabled", "true");
    submitBtn.classList.add("loading");
    submitBtn.innerHTML = `
      <span class="loader-spinner"></span>
      <span class="loading-text">Generating Quote...</span>
    `;
  }

  fetch("https://requestquote.w3apps.co/api/v1/quotes", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": "msesupplies:f89b1f5b-89c5-4d85-be72-39ac34c19d14"
    },
    body: JSON.stringify(quoteData)
  })
    .then(response => {
      if (!response.ok) throw new Error("Failed to send quote");
      console.log("Quote request sent successfully");
      return response.json();
    })
    .then(data => {
      console.log("API Response:", data);
      const quotesNumber = data.id;

      const emailsFetchData = {
        quote_id: quotesNumber,
        include_link: false,
        include_pdf: true,
        email_assignee: true
      };

      console.log("Sending email request:", emailsFetchData);

      return fetch("https://requestquote.w3apps.co/api/v1/quotes/email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "msesupplies:f89b1f5b-89c5-4d85-be72-39ac34c19d14"
        },
        body: JSON.stringify(emailsFetchData)
      });
    })
    .then(emailResponse => {
      if (emailResponse.ok) {
        console.log("✅ Email sent successfully");
        showThankYouPopup(); // Show modal after success
      } else {
        console.error("❌ Failed to send email");
      }
    })
    .catch(error => {
      console.error("Error:", error);
    })
    .finally(() => {
      // Restore button after all API calls
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.setAttribute("aria-disabled", "false");
        submitBtn.classList.remove("loading");
        submitBtn.innerHTML = "Submit Quote";
      }
    });
}

// ✅ Show Thank You popup after successful quote
function showThankYouPopup() {
  const modal = document.getElementById("quote-thankyou-modal");
  const actions = document.getElementById("quote-actions");

  if (!modal) return;

  modal.classList.remove("hidden");
  if (actions) actions.classList.remove("hidden");

  // Attach action buttons (only once)
  const checkoutBtn = document.getElementById("quote-to-checkout");
  const exitBtn = document.getElementById("quote-exit");

  if (checkoutBtn && !checkoutBtn.dataset.listenerAttached) {
    checkoutBtn.addEventListener("click", async () => {
      console.log("🚀 Adding products to Shopify cart for checkout…");

      await syncQuoteCartToShopifyCart(); // Sync items
      clearQuoteStorage(); // Clear data
      window.location.href = "/checkout"; // Go to checkout
    });
    checkoutBtn.dataset.listenerAttached = "true";
  }

  if (exitBtn && !exitBtn.dataset.listenerAttached) {
    exitBtn.addEventListener("click", () => {
      console.log("❌ Exiting quote, clearing all session/local storage");
      clearQuoteStorage();
      modal.classList.add("hidden");
      window.location.href = "/"; // Redirect to homepage or keep as is
    });
    exitBtn.dataset.listenerAttached = "true";
  }

  // Close if user clicks outside modal content
  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      modal.classList.add("hidden");
    }
  });
}